import { BaseComponent, BaseComponentAttrs } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";

/** 体育项接口 */
export interface SportItem {
  /** 状态 */
  status: number;
  /** 体育ID */
  sport_id: string;
  /** 分类ID */
  category_id: string;
  /** 数量 */
  count: number;
  /** 唯一标识 */
  key: number;
}

/** 体育组件属性接口 */
export interface SportAttrs extends BaseComponentAttrs {
  /** 数据列表 */
  data_list: SportItem[];
}

/** 体育组件类 */
export class SportComponent extends BaseComponent<SportAttrs> {
  constructor(data: Partial<BaseComponent<SportAttrs>> = {}) {
    super(data);
    this.type = CompType.sport;
  }

  /** 获取标题文本 */
  public getTitle(): string {
    return this.title;
  }
}
